import styled from "styled-components";
import { responsive } from "../../../../../../styles/constants.style";

export const DocumentsTabWrapper = styled.div`
  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100%;
  }

  .cell-document-name {
    min-width: 400px;
  }

  .cell-min-width {
    min-width: 200px;
  }

  .semi-header {
    display: flex;
    padding: 16px 28px;
    justify-content: flex-end;
    gap: 32px;
  }

  .documents-accordion {
    margin-top: 16px;
    margin-bottom: 32px;

    ${responsive.MOBILE`
          margin-bottom: 16px;
        `}
  }

  .document-name-link {
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
